import axios from 'axios'
import {BASE_URL, API_VERSION, EXHIBITORS} from '../endpoints'

export const GET_ALL_EXHIBITORS = 'GET_ALL_EXHIBITORS'
export const GET_EXHIBITOR = 'GET_EXHIBITOR'
export const ADD_EXHIBITOR = 'ADD_EXHIBITOR'
export const EDIT_EXHIBITOR = 'EDIT_EXHIBITOR'
export const DELETE_EXHIBITOR = 'DELETE_EXHIBITOR'
export const CLEAR_EXHIBITOR = 'CLEAR_EXHIBITOR'

export const getAllItems = (page, size, search) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${EXHIBITORS}/admin?page=${page}&size=${size}&search=${search}&admin=true`, options)
        .then((response) => {

            dispatch({
                type: GET_ALL_EXHIBITORS,
                payload: {
                    exhibitors: response.data.data,
                    total: response.data.data.totalElements // Adjust based on API
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const getItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${EXHIBITORS}/${id}`, options)
        .then((response) => {

            dispatch({
                type: GET_EXHIBITOR,
                payload: {
                    exhibitor: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};

export const addItem = (payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        }
    }
    return axios.post(BASE_URL + EXHIBITORS, payload, apiHeader)
        .then(response => {
            console.log(response.data)
            // dispatch({ type: ADD_EXHIBITOR, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const deleteItem = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.delete(BASE_URL + EXHIBITORS + '/' + id, apiHeader)
        .then(response => {
            // dispatch({ type: DELETE_EXHIBITOR, payload: id });
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const editItem = (id, payload) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken')
    let apiHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };
    return axios.patch(BASE_URL + EXHIBITORS + '/' + id, payload, apiHeader)
        .then(response => {
            // dispatch({ type: EDIT_EXHIBITOR, payload: response.data });
            return Promise.resolve()
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}

export const clearItem = () => (dispatch) => {
    dispatch({ type: CLEAR_EXHIBITOR });
}



// ---------------------  EXHIBITORS  ------------------------------ //
export const GET_EXHIBITS = 'GET_EXHIBITS'

export const getExhibits = (id) => (dispatch) => {
    const accessToken = window.localStorage.getItem('accessToken');
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + accessToken,
            'Accept': 'application/json',
        },
    };

    return axios.get(`${BASE_URL}${EXHIBITORS}/exhibitor`, options)
        .then((response) => {

            dispatch({
                type: GET_EXHIBITS,
                payload: {
                    exhibits: response.data.data,
                }
            });
            return Promise.resolve(response.data.data);
        })
        .catch((error) => {
            return Promise.reject(error.response?.data?.error);
        });
};
